<div class="redirect-modal">
  <div class="redirect-modal__content">
    <div class="redirect-modal__hero">
      <div class="redirect-modal__icon">
        <span class="material-icons">storefront</span>
      </div>

      <h2 class="redirect-modal__title">
        Acesso pela sua loja
      </h2>

      <p class="redirect-modal__lead">
        As funcionalidades da área de parceiros foram migradas para o site da sua loja.
      </p>
    </div>

    <div class="redirect-modal__path">
      <span class="redirect-modal__path-label">Onde acessar</span>
      <p class="redirect-modal__path-text">
        Faça login na sua loja e acesse <strong>Configurações da loja</strong> no menu do canto superior direito.
      </p>
    </div>

    <div class="redirect-modal__benefits">
      <div class="redirect-modal__benefit">Dados cadastrais</div>
      <div class="redirect-modal__benefit">Contratos</div>
      <div class="redirect-modal__benefit">Personalizações</div>
      <div class="redirect-modal__benefit">Comissões</div>
      <div class="redirect-modal__benefit">Cupons de desconto</div>
      <div class="redirect-modal__benefit">Carrinhos</div>
      <div class="redirect-modal__benefit">Vendas</div>
    </div>

    <p class="redirect-modal__footer">
      Clique no botão abaixo para continuar.
    </p>
  </div>

  <div class="redirect-modal__actions">
    <a
      class="btn btn-success redirect-modal__button"
      [href]="agencySite"
      [class.disabled]="!hasAgencySite"
      [attr.aria-disabled]="!hasAgencySite"
      [attr.tabindex]="!hasAgencySite ? -1 : null">
      {{ hasAgencySite ? 'Ir para a minha loja' : 'Link da loja indisponível' }}
    </a>

    <button
      type="button"
      class="redirect-modal__secondary"
      (click)="loginWithAnotherAccount()">
      Entrar com outra conta
    </button>
  </div>
</div>
